import _defineProperty from "/home/runner/work/marcom/marcom/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var warn = function warn(i18n, code, msg, rest) {
  var _i18n$services, _i18n$services$logger, _i18n$services2, _i18n$services2$logge, _console;
  var args = [msg, _objectSpread({
    code: code
  }, rest || {})];
  if (i18n !== null && i18n !== void 0 && (_i18n$services = i18n.services) !== null && _i18n$services !== void 0 && (_i18n$services$logger = _i18n$services.logger) !== null && _i18n$services$logger !== void 0 && _i18n$services$logger.forward) {
    return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
  }
  if (isString(args[0])) args[0] = "react-i18next:: ".concat(args[0]);
  if (i18n !== null && i18n !== void 0 && (_i18n$services2 = i18n.services) !== null && _i18n$services2 !== void 0 && (_i18n$services2$logge = _i18n$services2.logger) !== null && _i18n$services2$logge !== void 0 && _i18n$services2$logge.warn) {
    var _i18n$services$logger2;
    (_i18n$services$logger2 = i18n.services.logger).warn.apply(_i18n$services$logger2, args);
  } else if ((_console = console) !== null && _console !== void 0 && _console.warn) {
    var _console2;
    (_console2 = console).warn.apply(_console2, args);
  }
};
var alreadyWarned = {};
export var warnOnce = function warnOnce(i18n, code, msg, rest) {
  if (isString(msg) && alreadyWarned[msg]) return;
  if (isString(msg)) alreadyWarned[msg] = new Date();
  warn(i18n, code, msg, rest);
};
var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  };
};
export var loadNamespaces = function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
export var loadLanguages = function loadLanguages(i18n, lng, ns, cb) {
  if (isString(ns)) ns = [ns];
  if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return loadNamespaces(i18n, ns, cb);
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
export var hasLoadedNamespace = function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
      languages: i18n.languages
    });
    return true;
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      var _options$bindI18n;
      if (((_options$bindI18n = options.bindI18n) === null || _options$bindI18n === void 0 ? void 0 : _options$bindI18n.indexOf('languageChanging')) > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
};
export var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || (isString(Component) && Component.length > 0 ? Component : 'Unknown');
};
export var isString = function isString(obj) {
  return typeof obj === 'string';
};
export var isObject = function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
};